import { createContext } from "react";

export const LoyalitySettingContext = createContext(null);
